import {RouterProvider} from '@/lib/router';

import type {FC} from 'react';

const App: FC = () => <RouterProvider />;

export default App;
